import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SecureLS from "secure-ls";
import { getDashboardRouteForUser } from "../utils/dashboardRoute";

const ls = new SecureLS({ encodingType: "aes" });

const UnauthorizedAccess = () => {
  const navigate = useNavigate();
  const user = ls.get("user");

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        px: 3,
        textAlign: "center",
        bgcolor: "#f7f9fc",
      }}
    >
      <Typography component="h1" variant="h3" color="error" fontWeight={700}>
        Unauthorized Access
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 520 }}>
        Your role does not have permission to open this module.
      </Typography>
      <Button
        variant="contained"
        startIcon={<DashboardIcon />}
        onClick={() => navigate(getDashboardRouteForUser(user), { replace: true })}
        sx={{ mt: 1 }}
      >
        Back to Dashboard
      </Button>
    </Box>
  );
};

export default UnauthorizedAccess;
